module.exports = __webpack_public_path__ + "img/c642e72.jpg";